import React, { useState, useEffect } from 'react';
import './BlurText.css';
import { Typography } from '@mui/material';

const BlurText = ({ text='Loading', duration=1.3, offset=0, stretch=1.2, ...props }) => {
    return (
        <Typography className='blur-text' {...props}>
            {[...text].map((ch, i) => (
                <span key={i} style={{
                    animationDelay: offset + i * duration/text.length/stretch + 's',
                    animationDuration: duration + 's',
                }}>{ch}</span>))}
        </Typography>

    )
}


export default BlurText;